import api from './api';

export const login = async (pin) => {
  const response = await api.post('/auth/login', { pin });
  return response.data;
};

export const logout = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const checkAuth = async () => {
  const response = await api.get('/auth/check');
  return response.data;
};
